import { render, staticRenderFns } from "./infoLead.vue?vue&type=template&id=718d93da"
import script from "./infoLead.vue?vue&type=script&lang=js"
export * from "./infoLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports